import type { TourDefinition } from "../types";

export const welcomeTour: TourDefinition = {
  id: "welcome",
  titleKey: "onboarding.tours.welcome.title",
  descriptionKey: "onboarding.tours.welcome.description",
  estimatedMinutes: 2,
  steps: [
    {
      id: "sidebar-nav",
      targetSelector: "[data-sidebar='sidebar']",
      title: "Navigation",
      titleKey: "onboarding.tours.welcome.sidebarNav.title",
      description:
        "Access all your modules from the sidebar. Click any icon to navigate.",
      descriptionKey: "onboarding.tours.welcome.sidebarNav.description",
      placement: "right",
    },
    {
      id: "dashboard",
      targetSelector: "[data-tour='dashboard-stats']",
      title: "Your Dashboard",
      titleKey: "onboarding.tours.welcome.dashboard.title",
      description:
        "Get a quick overview of your operations — open work orders, upcoming schedules, and recent activity.",
      descriptionKey: "onboarding.tours.welcome.dashboard.description",
      placement: "bottom",
      highlightPulse: true,
    },
    {
      id: "create-button",
      targetSelector: "[data-tour='create-button']",
      title: "Create Records",
      titleKey: "onboarding.tours.welcome.createButton.title",
      description:
        "Use the + button to quickly create new locations, assets, work orders, and more.",
      descriptionKey: "onboarding.tours.welcome.createButton.description",
      placement: "bottom",
      action: "click",
      actionTarget: "[data-tour='create-button']",
      highlightPulse: true,
    },
    {
      id: "search",
      targetSelector: "[data-tour='search-input']",
      title: "Search & Filter",
      titleKey: "onboarding.tours.welcome.search.title",
      description:
        "Search any list by name, code, or keyword. Use the filter dropdown for advanced filtering.",
      descriptionKey: "onboarding.tours.welcome.search.description",
      placement: "bottom",
    },
    {
      id: "help",
      targetSelector: "[data-tour='help-button']",
      title: "Need Help?",
      titleKey: "onboarding.tours.welcome.help.title",
      description:
        "Click the help button anytime to see available tours and documentation.",
      descriptionKey: "onboarding.tours.welcome.help.description",
      placement: "bottom",
      celebration: "checkmark",
    },
  ],
};
